/*
 *  Удаляет пробел и тире в начале строки, также удаляет пробел между тире и фамилией, если она двойная
 */
export const deleteExcessSpaceAndDash = (value: string): string =>
    value.replace(/(^(-|\s))|(\s(?=-))/gm, '').replace(/(-\s)|(-{2,})/g, '-');
